import React, { useState, useEffect } from "react";
import "./Home.scss";
import { getInfo, getMonthly, getDaily } from "../../api/apiServiceFetch";
import DataGrid, {
	Column,
	FilterRow,
	HeaderFilter,
	Paging,
	Pager,
	Toolbar,
	LoadPanel,
	Selection,
	Summary,
	TotalItem,
	Item as ToolbarItem,
	Export,
} from "devextreme-react/data-grid";
import WorldMap from "./WorldMap";
import "devextreme/dist/css/dx.light.css";
import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import saveAs from "file-saver";
import { format, addDays, startOfMonth } from "date-fns";

// Helper function to format date to dd.mm.yyyy

const Home = () => {
	const [info, setInfo] = useState({});
	const [monthly, setMonthly] = useState([]);
	const [daily, setDaily] = useState([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);
	const [userAnalytics, setUserAnalytics] = useState();
	// Date setup
	const today = new Date();
	const firstDayOfMonth = startOfMonth(today);
	const tomorrow = addDays(today, 1);
	const [fromDate, setFromDate] = useState(
		format(firstDayOfMonth, "yyyy-MM-dd")
	);
	const [toDate, setToDate] = useState(format(tomorrow, "yyyy-MM-dd"));

	const [tempFromDate, setTempFromDate] = useState(fromDate);
	const [tempToDate, setTempToDate] = useState(toDate);

	const formatDate = (date) => format(new Date(date), "dd.MM.yyyy");
	useEffect(() => {
		const fetchData = async () => {
			setLoading(true);
			setError(null);
			try {
				const [monthlyData, dailyData, infoData] = await Promise.all([
					getMonthly(),
					getDaily(fromDate, toDate),
					getInfo(),
				]);
				setMonthly(monthlyData);
				setDaily(dailyData);
				setInfo(infoData);
			} catch (err) {
				console.error("Ошибка при загрузке данных:", err);
				setError("Не удалось загрузить данные.");
			} finally {
				setLoading(false);
			}
		};
		fetchData();
	}, [fromDate, toDate]);

	const handleApplyDates = (e) => {
		e.preventDefault(); // Предотвращаем любое стандартное поведение
		setFromDate(tempFromDate);
		setToDate(tempToDate);
	};

	const onExporting = (e, fileName) => {
		const workbook = new Workbook();
		const worksheet = workbook.addWorksheet("Sheet1");
		exportDataGrid({
			component: e.component,
			worksheet: worksheet,
			autoFilterEnabled: true,
		}).then(() => {
			workbook.xlsx.writeBuffer().then((buffer) => {
				saveAs(
					new Blob([buffer], { type: "application/octet-stream" }),
					`${fileName}.xlsx`
				);
			});
		});
		e.cancel = true;
	};

	if (loading)
		return (
			<div className="loading">
				<p>Loading...</p>
			</div>
		);
	if (error)
		return (
			<div className="error">
				<p style={{ color: "red" }}>{error}</p>
				<button onClick={() => window.location.reload()}>Try Again</button>
			</div>
		);
	const formatPrice = (data) => parseFloat(data.value).toFixed(2);

	const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042"];
	return (
		<div className="home">
			<div className="info-summary" style={{ marginBottom: "20px" }}>
				<table>
					<tr>
						<th colSpan={2}>Муж. - {info.man || 0}</th>
						<th colSpan={2}>Жен. - {info.woman || 0}</th>
					</tr>
				</table>
			</div>

			<h4>По месяцам</h4>
			<DataGrid
				dataSource={monthly}
				showBorders={true}
				columnAutoWidth={true}
				onExporting={(e) => onExporting(e, "MonthlyData")}
				// columnHidingEnabled={true}
			>
				<Column dataField="dt" caption="Месяц" />
				<Column caption="Зарегались" alignment="center">
					<Column dataField="userCntMan" caption="Все" />
					<Column dataField="manCnt" caption="Муж." />
					<Column dataField="womanCnt" caption="Жен." />
				</Column>
				<Column caption="Удалились" alignment="center">
					<Column dataField="delUserCnt" caption="Все" />
					<Column dataField="delManCnt" caption="Муж." />
					<Column dataField="delWomanCnt" caption="Жен." />
				</Column>

				<Column caption="ВСЕ ПОКУПКИ" alignment="center">
					<Column
						caption="Сумма"
						name="totalPrice"
						alignment="center"
						calculateCellValue={(rowData) =>
							(
								rowData.weekPrice +
								rowData.monthPrice +
								rowData.weekPricePlat +
								rowData.monthPricePlat +
								rowData.super3Price +
								rowData.super6Price +
								rowData.super9Price +
								rowData.newPrice +
								rowData.retryPrice
							).toFixed(2)
						}
						dataType="number"
					/>
					<Column
						caption="⭐️"
						name="totalPriceStars"
						alignment="center"
						calculateCellValue={(rowData) =>
							(
								rowData.weekPriceStars +
								rowData.monthPriceStars +
								rowData.weekPricePlatStars +
								rowData.monthPricePlatStars +
								rowData.super3PriceStars +
								rowData.super6PriceStars +
								rowData.super9PriceStars +
								rowData.newPriceStars +
								rowData.retryPriceStars
							).toFixed(2)
						}
						dataType="number"
					/>
				</Column>
				<Column caption="Plus (неделя)" alignment="center">
					<Column dataField="weekPrice" caption="Сумма" />
					<Column dataField="weekPriceStars" caption="⭐️" />
					<Column dataField="weekCount" caption="Количество" />
				</Column>
				<Column caption="Plus (месяц)" alignment="center">
					<Column dataField="monthPrice" caption="Сумма" />
					<Column dataField="monthPriceStars" caption="⭐️" />
					<Column dataField="monthCount" caption="Количество" />
				</Column>
				<Column caption="Platinum (неделя)" alignment="center">
					<Column dataField="weekPricePlat" caption="Сумма" />
					<Column dataField="weekPricePlatStars" caption="⭐️" />
					<Column dataField="weekCountPlat" caption="Количество" />
				</Column>
				<Column caption="Platinum (месяц)" alignment="center">
					<Column dataField="monthPricePlat" caption="Сумма" />
					<Column dataField="monthPricePlatStars" caption="⭐️" />
					<Column dataField="monthCountPlat" caption="Количество" />
				</Column>
				<Column caption="Комплименты" alignment="center">
					<Column caption="3" alignment="center">
						<Column dataField="super3Price" caption="Сумма" />
						<Column dataField="super3PriceStars" caption="⭐️" />
						<Column dataField="super3Count" caption="Количество" />
					</Column>
					<Column caption="6" alignment="center">
						<Column dataField="super6Price" caption="Сумма" />
						<Column dataField="super6PriceStars" caption="⭐️" />
						<Column dataField="super6Count" caption="Количество" />
					</Column>
					<Column caption="9" alignment="center">
						<Column dataField="super9Price" caption="Сумма" />
						<Column dataField="super9PriceStars" caption="⭐️" />
						<Column dataField="super9Count" caption="Количество" />
					</Column>
				</Column>
				<Column caption="Чистый лист" alignment="center">
					<Column dataField="newPrice" caption="Сумма" />
					<Column dataField="newPriceStars" caption="⭐️" />
					<Column dataField="newCount" caption="Количество" />
				</Column>
				<Column caption="Повторная регистрация" alignment="center">
					<Column dataField="retryPrice" caption="Сумма" />
					<Column dataField="retryPriceStars" caption="⭐️" />
					<Column dataField="retryCount" caption="Количество" />
				</Column>
				<FilterRow visible={true} />
				<HeaderFilter visible={true} />
				<Paging defaultPageSize={10} />
				<Pager
					showPageSizeSelector={true}
					allowedPageSizes={[5, 10, 20, "all"]}
				/>
				<Summary>
					<TotalItem column="userCntMan" summaryType="sum" />
					<TotalItem column="manCnt" summaryType="sum" />
					<TotalItem column="womanCnt" summaryType="sum" />
					<TotalItem column="delUserCnt" summaryType="sum" />
					<TotalItem column="delManCnt" summaryType="sum" />
					<TotalItem column="delWomanCnt" summaryType="sum" />
					<TotalItem
						column="totalPrice"
						summaryType="sum"
						customizeText={formatPrice}
					/>
					<TotalItem
						column="totalPriceStars"
						summaryType="sum"
						customizeText={formatPrice}
					/>
					<TotalItem
						column="weekPrice"
						summaryType="sum"
						customizeText={formatPrice}
					/>
					<TotalItem
						column="weekPriceStars"
						summaryType="sum"
						customizeText={formatPrice}
					/>
					<TotalItem column="weekCount" summaryType="sum" />
					<TotalItem
						column="monthPrice"
						summaryType="sum"
						customizeText={formatPrice}
					/>
					<TotalItem
						column="monthPriceStars"
						summaryType="sum"
						customizeText={formatPrice}
					/>
					<TotalItem column="monthCount" summaryType="sum" />
					<TotalItem
						column="weekPricePlat"
						summaryType="sum"
						customizeText={formatPrice}
					/>
					<TotalItem
						column="weekPricePlatStars"
						summaryType="sum"
						customizeText={formatPrice}
					/>
					<TotalItem column="weekCountPlat" summaryType="sum" />
					<TotalItem
						column="monthPricePlat"
						summaryType="sum"
						customizeText={formatPrice}
					/>
					<TotalItem
						column="monthPricePlatStars"
						summaryType="sum"
						customizeText={formatPrice}
					/>
					<TotalItem column="monthCountPlat" summaryType="sum" />
					<TotalItem
						column="super3Price"
						summaryType="sum"
						customizeText={formatPrice}
					/>
					<TotalItem
						column="super3PriceStars"
						summaryType="sum"
						customizeText={formatPrice}
					/>
					<TotalItem column="super3Count" summaryType="sum" />
					<TotalItem
						column="super6Price"
						summaryType="sum"
						customizeText={formatPrice}
					/>
					<TotalItem
						column="super6PriceStars"
						summaryType="sum"
						customizeText={formatPrice}
					/>
					<TotalItem column="super6Count" summaryType="sum" />
					<TotalItem
						column="super9Price"
						summaryType="sum"
						customizeText={formatPrice}
					/>
					<TotalItem
						column="super9PriceStars"
						summaryType="sum"
						customizeText={formatPrice}
					/>
					<TotalItem column="super9Count" summaryType="sum" />
					<TotalItem
						column="newPrice"
						summaryType="sum"
						customizeText={formatPrice}
					/>
					<TotalItem
						column="newPriceStars"
						summaryType="sum"
						customizeText={formatPrice}
					/>
					<TotalItem column="newCount" summaryType="sum" />
					<TotalItem
						column="retryPrice"
						summaryType="sum"
						customizeText={formatPrice}
					/>
					<TotalItem
						column="retryPriceStars"
						summaryType="sum"
						customizeText={formatPrice}
					/>
					<TotalItem column="retryCount" summaryType="sum" />
				</Summary>
				<Toolbar>
					<ToolbarItem name="exportButton" />
				</Toolbar>
				<Export enabled={true} />
			</DataGrid>

			<h4>По дням</h4>
			<div className="date-pickers" style={{ marginBottom: "20px" }}>
				<label>
					начало:
					<input
						type="date"
						value={tempFromDate}
						onChange={(e) => setTempFromDate(e.target.value)}
						style={{ marginLeft: "10px" }}
					/>
				</label>
				<label style={{ marginLeft: "20px" }}>
					конец:
					<input
						type="date"
						value={tempToDate}
						onChange={(e) => setTempToDate(e.target.value)}
						style={{ marginLeft: "10px" }}
					/>
				</label>
				<button onClick={handleApplyDates} style={{ marginLeft: "20px" }}>
					Применить
				</button>
			</div>
			<p>
				Выбранный период: {formatDate(fromDate)} - {formatDate(toDate)}
			</p>
			<DataGrid
				dataSource={daily}
				showBorders={true}
				columnAutoWidth={true}
				onExporting={(e) => onExporting(e, "DailyData")}
				// columnHidingEnabled={true}
			>
				<Column
					dataField="dt"
					caption="день"
					dataType="date"
					format="dd.MM.yyyy"
				/>
				<Column caption="Зарегались" alignment="center">
					<Column dataField="userCntMan" caption="Все" />
					<Column dataField="manCnt" caption="Муж." />
					<Column dataField="womanCnt" caption="Жен." />
				</Column>
				<Column caption="Удалились" alignment="center">
					<Column dataField="delUserCnt" caption="Все" />
					<Column dataField="delManCnt" caption="Муж." />
					<Column dataField="delWomanCnt" caption="Жен." />
				</Column>
				<Column caption="ВСЕ ПОКУПКИ" alignment="center">
					<Column
						caption="Сумма"
						name="totalPrice"
						alignment="center"
						calculateCellValue={(rowData) =>
							(
								rowData.weekPrice +
								rowData.monthPrice +
								rowData.weekPricePlat +
								rowData.monthPricePlat +
								rowData.super3Price +
								rowData.super6Price +
								rowData.super9Price +
								rowData.newPrice +
								rowData.retryPrice
							).toFixed(2)
						}
						dataType="number"
					/>
					<Column
						caption="⭐️"
						name="totalPriceStars"
						alignment="center"
						calculateCellValue={(rowData) =>
							(
								rowData.weekPriceStars +
								rowData.monthPriceStars +
								rowData.weekPricePlatStars +
								rowData.monthPricePlatStars +
								rowData.super3PriceStars +
								rowData.super6PriceStars +
								rowData.super9PriceStars +
								rowData.newPriceStars +
								rowData.retryPriceStars
							).toFixed(2)
						}
						dataType="number"
					/>
				</Column>
				<Column caption="Plus (неделя)" alignment="center">
					<Column dataField="weekPrice" caption="Сумма" />
					<Column dataField="weekPriceStars" caption="⭐️" />
					<Column dataField="weekCount" caption="Количество" />
				</Column>
				<Column caption="Plus (месяц)" alignment="center">
					<Column dataField="monthPrice" caption="Сумма" />
					<Column dataField="monthPriceStars" caption="⭐️" />
					<Column dataField="monthCount" caption="Количество" />
				</Column>
				<Column caption="Platinum (неделя)" alignment="center">
					<Column dataField="weekPricePlat" caption="Сумма" />
					<Column dataField="weekPricePlatStars" caption="⭐️" />
					<Column dataField="weekCountPlat" caption="Количество" />
				</Column>
				<Column caption="Platinum (месяц)" alignment="center">
					<Column dataField="monthPricePlat" caption="Сумма" />
					<Column dataField="monthPricePlatStars" caption="⭐️" />
					<Column dataField="monthCountPlat" caption="Количество" />
				</Column>
				<Column caption="Комплименты" alignment="center">
					<Column caption="3" alignment="center">
						<Column dataField="super3Price" caption="Сумма" />
						<Column dataField="super3PriceStars" caption="⭐️" />
						<Column dataField="super3Count" caption="Количество" />
					</Column>
					<Column caption="6" alignment="center">
						<Column dataField="super6Price" caption="Сумма" />
						<Column dataField="super6PriceStars" caption="⭐️" />
						<Column dataField="super6Count" caption="Количество" />
					</Column>
					<Column caption="9" alignment="center">
						<Column dataField="super9Price" caption="Сумма" />
						<Column dataField="super9PriceStars" caption="⭐️" />
						<Column dataField="super9Count" caption="Количество" />
					</Column>
				</Column>
				<Column caption="Чистый лист" alignment="center">
					<Column dataField="newPrice" caption="Сумма" />
					<Column dataField="newPriceStars" caption="⭐️" />
					<Column dataField="newCount" caption="Количество" />
				</Column>
				<Column caption="Повторная регистрация" alignment="center">
					<Column dataField="retryPrice" caption="Сумма" />
					<Column dataField="retryPriceStars" caption="⭐️" />
					<Column dataField="retryCount" caption="Количество" />
				</Column>
				<FilterRow visible={true} />
				<HeaderFilter visible={true} />
				<Paging defaultPageSize={10} />
				<Pager
					showPageSizeSelector={true}
					allowedPageSizes={[5, 10, 20, "all"]}
				/>
				<Summary>
					<TotalItem column="userCntMan" summaryType="sum" />
					<TotalItem column="manCnt" summaryType="sum" />
					<TotalItem column="womanCnt" summaryType="sum" />
					<TotalItem column="delUserCnt" summaryType="sum" />
					<TotalItem column="delManCnt" summaryType="sum" />
					<TotalItem column="delWomanCnt" summaryType="sum" />
					<TotalItem
						column="totalPrice"
						summaryType="sum"
						customizeText={formatPrice}
					/>
					<TotalItem
						column="totalPriceStars"
						summaryType="sum"
						customizeText={formatPrice}
					/>
					<TotalItem
						column="weekPrice"
						summaryType="sum"
						customizeText={formatPrice}
					/>
					<TotalItem
						column="weekPriceStars"
						summaryType="sum"
						customizeText={formatPrice}
					/>
					<TotalItem column="weekCount" summaryType="sum" />
					<TotalItem
						column="monthPrice"
						summaryType="sum"
						customizeText={formatPrice}
					/>
					<TotalItem
						column="monthPriceStars"
						summaryType="sum"
						customizeText={formatPrice}
					/>
					<TotalItem column="monthCount" summaryType="sum" />
					<TotalItem
						column="weekPricePlat"
						summaryType="sum"
						customizeText={formatPrice}
					/>
					<TotalItem
						column="weekPricePlatStars"
						summaryType="sum"
						customizeText={formatPrice}
					/>
					<TotalItem column="weekCountPlat" summaryType="sum" />
					<TotalItem
						column="monthPricePlat"
						summaryType="sum"
						customizeText={formatPrice}
					/>
					<TotalItem
						column="monthPricePlatStars"
						summaryType="sum"
						customizeText={formatPrice}
					/>
					<TotalItem column="monthCountPlat" summaryType="sum" />
					<TotalItem
						column="super3Price"
						summaryType="sum"
						customizeText={formatPrice}
					/>
					<TotalItem
						column="super3PriceStars"
						summaryType="sum"
						customizeText={formatPrice}
					/>
					<TotalItem column="super3Count" summaryType="sum" />
					<TotalItem
						column="super6Price"
						summaryType="sum"
						customizeText={formatPrice}
					/>
					<TotalItem
						column="super6PriceStars"
						summaryType="sum"
						customizeText={formatPrice}
					/>
					<TotalItem column="super6Count" summaryType="sum" />
					<TotalItem
						column="super9Price"
						summaryType="sum"
						customizeText={formatPrice}
					/>
					<TotalItem
						column="super9PriceStars"
						summaryType="sum"
						customizeText={formatPrice}
					/>
					<TotalItem column="super9Count" summaryType="sum" />
					<TotalItem
						column="newPrice"
						summaryType="sum"
						customizeText={formatPrice}
					/>
					<TotalItem
						column="newPriceStars"
						summaryType="sum"
						customizeText={formatPrice}
					/>
					<TotalItem column="newCount" summaryType="sum" />
					<TotalItem
						column="retryPrice"
						summaryType="sum"
						customizeText={formatPrice}
					/>
					<TotalItem
						column="retryPriceStars"
						summaryType="sum"
						customizeText={formatPrice}
					/>
					<TotalItem column="retryCount" summaryType="sum" />
				</Summary>
				<Toolbar>
					<ToolbarItem name="exportButton" />
				</Toolbar>
				<Export enabled={true} />
			</DataGrid>
		</div>
	);
};

export default Home;
